import React from 'react';
import ImageLoader from '../images/ImageLoader';
import Modal from '../modal/Modal';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreLink } from '../link/Link';
import { Button } from 'react-bootstrap';

var PegRewardCardModal = function PegRewardCardModal(props) {
  var _Link$value;

  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      _props$userPegs = props.userPegs,
      userPegs = _props$userPegs === void 0 ? 0 : _props$userPegs,
      show = props.show,
      hide = props.hide;
  var Image = model.Image,
      RewardAmount = model.RewardAmount,
      Name = model.Name,
      Description = model.Description,
      PegsAvailableMessage = model.PegsAvailableMessage,
      PegsNeededMessage = model.PegsNeededMessage,
      ButtonAvailableReward = model.ButtonAvailableReward,
      ButtonUnavailableReward = model.ButtonUnavailableReward,
      Link = model.Link;
  var rewardAmountArr = RewardAmount.value.split(' ');
  var message = '';

  if (parseInt(userPegs) >= parseInt(rewardAmountArr === null || rewardAmountArr === void 0 ? void 0 : rewardAmountArr[0])) {
    message = PegsAvailableMessage.value;
  } else {
    message = PegsNeededMessage.value.replace('5', (rewardAmountArr === null || rewardAmountArr === void 0 ? void 0 : rewardAmountArr[0]) - userPegs).replace('30', rewardAmountArr === null || rewardAmountArr === void 0 ? void 0 : rewardAmountArr[0]);
  }

  return /*#__PURE__*/React.createElement(Modal, {
    className: 'loyalty-modal loyalty-modal--peg-reward-card',
    show: show,
    hide: hide,
    hideCloseButton: true,
    backdrop: true
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-peg-reward-card-modal'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-peg-reward-card-modal__reward-amount'
  }, /*#__PURE__*/React.createElement("span", {
    className: "cb-peg-reward-card-modal__reward-amount__label-amount"
  }, rewardAmountArr === null || rewardAmountArr === void 0 ? void 0 : rewardAmountArr[0]), /*#__PURE__*/React.createElement("span", {
    className: "cb-peg-reward-card-modal__reward-amount__label-currency"
  }, rewardAmountArr === null || rewardAmountArr === void 0 ? void 0 : rewardAmountArr[1])), /*#__PURE__*/React.createElement("div", {
    className: 'cb-peg-reward-card-modal__image-container'
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    media: Image,
    type: 'product',
    className: "cb-card__image"
  })), /*#__PURE__*/React.createElement("div", {
    className: 'cb-peg-reward-card-modal__body-container'
  }, /*#__PURE__*/React.createElement(Text, {
    tag: 'span',
    className: 'cb-peg-reward-card-modal__body-container__info',
    field: {
      value: message
    }
  }), /*#__PURE__*/React.createElement(Text, {
    tag: 'span',
    className: 'cb-peg-reward-card-modal__body-container__header',
    field: Name
  }), /*#__PURE__*/React.createElement(RichText, {
    field: Description,
    tag: "span",
    className: 'cb-peg-reward-card-modal__body-container__copy'
  }), parseInt(userPegs) >= parseInt(rewardAmountArr === null || rewardAmountArr === void 0 ? void 0 : rewardAmountArr[0]) ? (ButtonAvailableReward === null || ButtonAvailableReward === void 0 ? void 0 : ButtonAvailableReward.value) != '' && /*#__PURE__*/React.createElement(SitecoreLink, {
    field: {
      value: {
        text: ButtonAvailableReward.value,
        title: ButtonAvailableReward.value,
        href: (Link === null || Link === void 0 ? void 0 : (_Link$value = Link.value) === null || _Link$value === void 0 ? void 0 : _Link$value.href) || '#'
      }
    },
    className: 'cb-button-primary cb-peg-reward-card-modal__body-container__button'
  }) : (ButtonUnavailableReward === null || ButtonUnavailableReward === void 0 ? void 0 : ButtonUnavailableReward.value) != '' && /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-primary cb-peg-reward-card-modal__body-container__button",
    onClick: hide
  }, ButtonUnavailableReward === null || ButtonUnavailableReward === void 0 ? void 0 : ButtonUnavailableReward.value))));
};

export default PegRewardCardModal;